import { DatePipe, DecimalPipe, NgClass, UpperCasePipe } from '@angular/common';
import {
  ChangeDetectorRef,
  Component,
  OnInit,
  input,
  output,
  inject,
  AfterViewInit,
} from '@angular/core';
import {
  UntypedFormGroup,
  UntypedFormBuilder,
  FormsModule,
  ReactiveFormsModule,
  UntypedFormControl,
  Validators,
} from '@angular/forms';
import {
  ClassTypeService,
  ClassService,
  TimeconversionService,
  ToastMessageService,
} from '@fitness-force/api';
import { GooglePlacesComponent } from '@fitness-force/common/google-places';
import { CONSTANTS_SCHEDULE } from '@fitness-force/constants';
import {
  ClassAppointmentBehaviour,
  ClassStatus,
  ClientBookingStatus,
  Ienum,
  StaffStatus,
} from '@fitness-force/enum';
import { AppErrors } from '@fitness-force/models';
import { ErrorMsgComponent } from '@fitness-force/errors';
import type {
  Classes,
  Class,
  ClassType,
  RepeatRuleResponse,
  IPSetting,
  Client,
  CancelClassRequest,
  ClassTypeById,
  RescheduleRecurringClassRequest,
  Room,
  SubstituteCoachInClassRequest,
  UpdateClassRequest,
  ClassRecurringTemplateResponse,
} from '@fitness-force/models';
import { DateTimeFormatPipe } from '@fitness-force/pipes/datetime-format';

import { Store } from '@ngrx/store';
import { TranslateModule, TranslateService } from '@ngx-translate/core';
import { StaffAvailabilityService } from '@fitness-force/staff-availability-lib';
import { AvatarModule } from 'primeng/avatar';
import { ButtonModule } from 'primeng/button';
import { DatePickerModule } from 'primeng/datepicker';
import { ConfirmPopupModule } from 'primeng/confirmpopup';
import { DialogModule } from 'primeng/dialog';
import { DividerModule } from 'primeng/divider';
import { SelectModule } from 'primeng/select';
import { InputNumberModule } from 'primeng/inputnumber';
import { ToggleSwitchModule } from 'primeng/toggleswitch';
import { InputTextModule } from 'primeng/inputtext';

import { PopoverModule } from 'primeng/popover';
import { RadioButtonModule } from 'primeng/radiobutton';
import { ScrollPanelModule } from 'primeng/scrollpanel';
import { DrawerModule } from 'primeng/drawer';
import { SkeletonModule } from 'primeng/skeleton';
import { StyleClassModule } from 'primeng/styleclass';
import { MessageModule } from 'primeng/message';

import { BehaviorSubject, Observable, Subject, debounceTime, of } from 'rxjs';
import { InputNumberComponent } from '../../../input-number/input-number.component';
import { RruleComponent } from '../../../rrule/rrule.component';
import { SelectRoomComponent } from '../../../select-room/select-room.component';
import { AssignedToComponent } from '../../../staff/assigned-to/assigned-to.component';
import {
  LOCATION_STATE,
  CLASS_TYPE_STATE,
  STAFF_STATE,
} from '@fitness-force/state';
import {
  CheckRecurringAvailability,
  StaffAvailableResponse,
} from '@fitness-force/staff-availability-lib';
import { rrulestr } from 'rrule';
import { ConfirmationService } from 'primeng/api';

@Component({
  selector: 'view-recurring-class',
  templateUrl: './view-recurring-class.component.html',
  styleUrls: ['./view-recurring-class.component.css'],
  standalone: true,
  imports: [
    DialogModule,
    InputTextModule,
    ButtonModule,
    DatePickerModule,
    SelectModule,
    FormsModule,
    DividerModule,
    AvatarModule,
    StyleClassModule,
    FormsModule,
    ReactiveFormsModule,
    RruleComponent,
    AssignedToComponent,
    ErrorMsgComponent,
    SkeletonModule,
    PopoverModule,
    DateTimeFormatPipe,
    ScrollPanelModule,
    InputNumberModule,
    GooglePlacesComponent,
    RadioButtonModule,
    AvatarModule,
    DrawerModule,
    SelectRoomComponent,
    ToggleSwitchModule,
    InputNumberComponent,
    ConfirmPopupModule,
    TranslateModule,
    MessageModule,
    DecimalPipe,
    NgClass,
    UpperCasePipe,
  ],
})
export class ViewRecurringClassComponent implements OnInit, AfterViewInit {
  private readonly store = inject(Store);
  private readonly translate = inject(TranslateService);
  private readonly fb = inject(UntypedFormBuilder);
  private readonly toastMessageService = inject(ToastMessageService);
  private readonly classTypeService = inject(ClassTypeService);
  private readonly classService = inject(ClassService);
  private readonly timeConversionService = inject(TimeconversionService);
  datePipe = inject(DatePipe);
  private readonly staffAvailabilityService = inject(StaffAvailabilityService);
  private readonly cd = inject(ChangeDetectorRef);
  private readonly confirmationService = inject(ConfirmationService);
  toastService = inject(ToastMessageService);

  readonly viewClass = input<boolean>(false, { alias: 'visible' });
  readonly tenantId = input<number>(0);
  readonly classData = input.required<Classes>({});
  readonly classType = input<string>('Class');
  readonly hideViewClass = output<boolean>({ alias: 'CloseViewClass' });
  readonly emitUpdatedData = output<any>({ alias: 'emitUpdatedData' });
  readonly reloadData = output<any>({ alias: 'reloadData' });

  showApptSubType = new BehaviorSubject(false);
  getAccessedStaffList$: Observable<any> | any;
  classTypeList$ = new BehaviorSubject<ClassType[]>([]);
  classSubTypeList$ = new BehaviorSubject<any[]>([]);
  roomList$ = new BehaviorSubject<any[]>([]);
  classObj!: ClassRecurringTemplateResponse;

  selectedClassSubType: Observable<any> | any;
  selectedClassType: Observable<ClassType> | any;
  selectedTrainerId = new BehaviorSubject(0);
  selectedRoomId = new BehaviorSubject(0);
  selectedBehaviourType: any;
  selectedRoom: { name: string } | any;
  selectedTrainer:
    | { name: string; availability: string; ff_picture: string }
    | undefined;

  classViewForm: UntypedFormGroup = new UntypedFormGroup({});
  deleteClassForm: UntypedFormGroup = new UntypedFormGroup({});
  updateEventForm: UntypedFormGroup = new UntypedFormGroup({});

  isVirtal: boolean = false;

  duplicateClass: boolean = false;
  behaviourTypes: any[] = CONSTANTS_SCHEDULE.CLASS_APPOINTMENT_BEHAVIOUR;
  types = ClassAppointmentBehaviour;

  dateSelectionOption: any;

  showClientDetails = new BehaviorSubject(false);

  behaviours(): Array<string> {
    const keys = Object.keys(this.types);
    return keys.slice(keys.length / 2);
  }

  showRRule: boolean = false;
  RRuleObject = <RepeatRuleResponse>{};
  minimumDate = new Date();
  errorDataModal = [] as any;
  errorMessages = [] as any;
  showErrorPopup$ = new BehaviorSubject(false);

  reservationLimitEdit: boolean = false;
  waitListEdit: boolean = false;
  dropIns!: any[];
  selectedDropin: { name: string; value: boolean } | undefined;

  markCompleted: boolean = false;
  markAllAttended: boolean = false;

  cancelClassPopup: boolean = false;
  deleteClassPopup: boolean = false;
  showAddClientConfirmPopup: boolean = false;

  searchlocations: Observable<any[]> | any;
  selectedLocation: { name: string; lat: number; lon: number } | any = {};

  currentLocation!: IPSetting;

  selectedClient: Client | any;
  showRecurringEventUpdatePopup: boolean = false;
  updateEvent: string = '';
  currentRequestPayload: any;
  updateData: any;

  rescheduleDate: any;
  rescheduleTime: any;

  claims: string[] = ['can_take_class'];
  claims$: Observable<string[]> = of(['can_take_class']);
  isClassCompletedOrCancelled: boolean = false;

  showMiniSearch = new BehaviorSubject<boolean>(true);
  filterStaffIds = new BehaviorSubject<number[]>([0]);
  filterStaffIds$: Observable<number[]> = of([0]);
  calendarOptions: any;
  memberstatus: any[];
  classDataObject: Classes | undefined;

  showLeftView: boolean = true;
  showMedicalAlert: boolean = false;

  classActions: any[];
  selectedClassAction: { key: string; name: string; icon: string } | undefined;

  private readonly url = new Subject<string>();
  private readonly comments = new Subject<string>();

  isAcceptTrialChecked: boolean = false;
  staffAppointmentAvailability: any = new Map();
  isStaffAvailable: boolean = true;
  btnLoading: boolean = false;
  checkAvailability: boolean = true;

  showBookingTab = new BehaviorSubject<boolean>(true);
  showSkeleton$ = new BehaviorSubject<boolean>(true);

  constructor() {
    this.classActions = [
      {
        key: 'CANCEL_CLASS',
        name: 'Cancel this Class',
        icon: 'fa fa-minus-circle',
        show: true,
      },
      // { key:"DELETE", name: 'Delete this class', icon: 'fa fa-times text-xl-circle', show:true },
      {
        key: 'CONVERT_PHYSICAL',
        name: 'Convert this class to Virtual',
        icon: 'fa fa-building',
        show: true,
      },
      {
        key: 'CONVERT_VIRTUAL',
        name: 'Convert this class to Virtual',
        icon: 'fa fa-video',
        show: true,
      },
    ];

    this.dropIns = [
      { name: 'Allowed', value: true },
      { name: 'Not Allowed', value: false },
    ];
    this.searchlocations = [];
    this.dateSelectionOption = {
      onClose: (ev: any, inst: any) => {
        const selectedDate = inst.getVal();
        if (selectedDate != this.GetStartDateFormValue)
          this.OnScheduleDateSelect(selectedDate);
      },
    };
  }

  ngOnInit(): void {
    console.log('classData =>', this.classData());
    this.componentInit();
  }

  componentInit() {
    this.classDataObject = this.classData();
    this.store.select(LOCATION_STATE).subscribe((responseData: IPSetting) => {
      this.currentLocation = responseData;
    });
    this.GetClassRecurringTemplate();
    const classData = this.classData();
    this.selectedTrainerId.next(classData.coach_id);
    this.selectedRoomId.next(classData.room.room_id);
    this.isClassCompletedOrCancelled =
      classData.status == ClassStatus.Completed.toString() ||
      classData.status == ClassStatus[ClassStatus.Completed] ||
      classData.status == ClassStatus.Cancelled.toString() ||
      classData.status == ClassStatus[ClassStatus.Cancelled]
        ? true
        : false;
    this.LoadForm();
    this.GetClassTypes();
    this.GetStaffs();
  }

  ngAfterViewInit() {
    this.deleteClassForm = this.fb.group({ cancellation_reason: [''] });
    this.updateEventForm = this.fb.group({
      updateEvent: ['thisevent', [Validators.required]],
    });
    this.comments.pipe(debounceTime(2000)).subscribe(() => {
      this.EditCommnentsEvent();
    });

    this.url.pipe(debounceTime(2000)).subscribe(() => {
      this.UpdateVirtualURLEvent();
    });
  }

  LoadForm() {
    this.isAcceptTrialChecked = this.classData().accepts_trial;
    this.classViewForm = this.fb.group({
      classType: [{ value: '', disabled: true }],
      classSubType: [{ value: '', disabled: true }],
      selectedBehaviourType: [{ value: '', disabled: true }],
      selectedTrainer: ['', [Validators.required]],
      startDate: [
        this.setFullDate(
          this.classData().recurring_start_date,
          this.classData().start_time,
        ),
        [Validators.required],
      ],
      selectedRoom: [''],
      comments: [''],
      virtualUrl: [''],
      maxCapacity: [this.classData().max_capacity, [Validators.required]],
      maxWaitlist: [this.classData().max_waitlist, [Validators.required]],
      isDropInAllowed: [this.selectedDropin, [Validators.required]],
      rRule: [''],
      placeName: [''],
      placeId: [this.classData().place_id],
      latitude: [this.classData().latitude],
      longitude: [this.classData().longitude],
      accepts_trial: [this.isAcceptTrialChecked],
      selectedAction: [],
    });

    if (this.isClassCompletedOrCancelled) {
      Object.keys(this.classViewForm.controls).forEach((field) => {
        const control = this.classViewForm.get(field);
        if (field != 'selectedAction') control?.disable({ onlySelf: true });
      });
    }
    if (this.isClassCompletedOrCancelled)
      this.classActions.forEach((o) => {
        if (
          o.key.toLowerCase() == 'cancel_class' ||
          o.key.toLowerCase() == 'convert_physical' ||
          o.key.toLowerCase() == 'convert_virtual'
        )
          o.show = false;
      });
    else if (this.isVirtal)
      this.classActions.forEach((o) => {
        if (o.key.toLowerCase() == 'convert_virtual') o.show = false;
      });
    else
      this.classActions.forEach((o) => {
        if (o.key.toLowerCase() == 'convert_physical') o.show = false;
      });
  }

  GetClassRecurringTemplate() {
    this.classService
      .GetClassRecurringTemplateById(
        this.tenantId(),
        this.classData()?.recurring_template_id,
      )
      .subscribe({
        next: (response: ClassRecurringTemplateResponse) => {
          this.classObj = response;
          this.showClientDetails.next(true);
          this.markCompleted =
            this.classObj.status == ClassStatus.Completed.toString() ||
            this.classObj.status == ClassStatus[ClassStatus.Completed]
              ? true
              : false;
          this.CommentsFormControl.setValue(this.classObj.comments);
          this.MaxCapacityFormControl.setValue(this.classObj.max_capacity);
          this.MaxWaitListFormControl.setValue(this.classObj.max_waitlist);
          this.VirtualUrlFormControl.setValue(this.classObj.virtual_url);
          // Only parse recurring rule if it exists and is not empty
          if (
            this.classObj.recurring_rule &&
            this.classObj.recurring_rule.trim() !== ''
          ) {
            this.RRuleObject.RRule = this.classObj.recurring_rule;
            this.RRuleObject.RRuleText = rrulestr(
              this.classObj.recurring_rule,
            ).toText();
          } else {
            this.RRuleObject.RRule = undefined as any;
            this.RRuleObject.RRuleText = undefined as any;
          }
          this.isVirtal = this.classObj?.is_virtual;
          this.selectedDropin = this.dropIns.find(
            (d) => d.value == this.classObj.is_dropin_allowed,
          );
          this.DropInFormControl.setValue(this.selectedDropin);
          if (this.markCompleted)
            this.classActions.forEach((o) => {
              if (
                o.key.toLowerCase() == 'cancel_class' ||
                o.key.toLowerCase() == 'convert_physical' ||
                o.key.toLowerCase() == 'convert_virtual'
              )
                o.show = false;
            });
          else if (this.classObj.is_virtual)
            this.classActions.forEach((o) => {
              if (o.key.toLowerCase() == 'convert_virtual') o.show = false;
            });
          else
            this.classActions.forEach((o) => {
              if (o.key.toLowerCase() == 'convert_physical') o.show = false;
            });

          this.GetClassType(this.classData().class_type.type_id);
          this.showSkeleton$.next(false);
          this.cd.detectChanges();
        },
        error: () => {
          this.showClientDetails.next(true);
          this.showSkeleton$.next(false);
          this.cd.detectChanges();
        },
      });
  }

  GetClassTypes() {
    this.store
      .select(CLASS_TYPE_STATE)
      .subscribe((responseData: ClassType[]) => {
        this.classTypeList$.next(responseData);
        this.selectedClassType = this.classTypeList$.value.find(
          (type: { id: number }) =>
            type.id == this.classData().class_type.type_id,
        );
        this.SelectedClassTypeFormControl.setValue(this.selectedClassType);
        this.selectedBehaviourType = this.behaviourTypes.find(
          (b) => b.value == this.classData().behaviour,
        );
        this.SelectedBehaviourTypeFormControl.setValue(
          this.selectedBehaviourType,
        );
      });
  }

  GetClassType(classTypeId: number) {
    this.classTypeService
      .getSingleClassType(this.tenantId(), classTypeId)
      .subscribe({
        next: (response: ClassTypeById) => {
          if (response.subtypes) {
            this.classSubTypeList$.next(response.subtypes);
            this.selectedClassSubType = response.subtypes.find(
              (subType: { name_primary_language: string }) =>
                subType.name_primary_language.toLowerCase() ==
                this.classObj.subtype_name_primary_language.toLowerCase(),
            );
            if (this.selectedClassSubType)
              this.SelectedClassSubTypeFormControl.setValue(
                this.selectedClassSubType,
              );
            else this.selectedClassSubType = response.subtypes[0];
          } else {
            this.selectedClassSubType = null;
          }
        },
        error: () => {
          this.selectedClassSubType = null;
        },
      });
  }

  GetStaffs() {
    this.store.select(STAFF_STATE).subscribe((data: any) => {
      if (data?.staffList && data.staffList.length > 0) {
        const validStaff: number[] = [];
        this.getAccessedStaffList$ = data.staffList.filter((staff: any) => {
          const oStaffStatus = this.OStaffStatus.find(
            (o: any) => o.value == staff.status || o.key == staff.status,
          );
          if (
            oStaffStatus?.value == StaffStatus.Active ||
            oStaffStatus?.key == StaffStatus.Active
          ) {
            if (
              staff.role.toLowerCase() == 'admin' ||
              (staff.role.toLowerCase() == 'staff' && staff.can_take_class)
            ) {
              validStaff.push(staff.id);
              return staff;
            }
          }
        });
        this.filterStaffIds.next(validStaff);
        this.filterStaffIds$ = of(validStaff);
      }
    });
    this.claims$ = of(this.claims);
  }

  ToggleVirtual(isVirtual: boolean) {
    this.isVirtal = isVirtual;
    if (isVirtual) {
      this.classActions.forEach((o) => {
        if (o.key.toLowerCase() == 'convert_virtual') o.show = false;
      });
      this.classActions.forEach((o) => {
        if (o.key.toLowerCase() == 'convert_physical') o.show = true;
      });
      this.SelectedRoomFormControl.setValidators(null);
      this.VirtualUrlFormControl.setValidators(null);
      this.UpdateVirtualURLEvent();
    } else {
      this.classActions.forEach((o) => {
        if (o.key.toLowerCase() == 'convert_physical') o.show = false;
      });
      this.classActions.forEach((o) => {
        if (o.key.toLowerCase() == 'convert_virtual') o.show = true;
      });
      this.SelectedRoomFormControl.setValidators(
        this.selectedClassType?.is_room_mandatory
          ? Validators.required
          : null,
      );
      this.VirtualUrlFormControl.setValidators(null);
      this.UpdateVirtualURLEvent();
      if (
        this.selectedClassType.is_room_mandatory &&
        (this.SelectedRoomFormControl.value == null ||
          this.SelectedRoomFormControl.value == '')
      ) {
        this.classViewForm.markAllAsTouched();
      } else {
        this.updateRoom();
      }
    }
  }

  ClosePopup() {
    this.hideViewClass.emit(true);
    this.hideViewClass.emit(this.viewClass());
  }

  CloseViewClass(event: any) {
    this.ClosePopup();
  }

  async OnScheduleDateSelect(e: any) {
    if (this.GetStartDateFormValue) {
      this.updateEvent = 'OnScheduleDateTimeChange';
      this.checkStaffAvailability();
      await this.timeout(1000);
      this.RescheduleRecurringClass();
    }
  }

  getSelectedRoomEvent(room: Room) {
    this.updateEvent = 'RoomChange';
    this.currentRequestPayload = this.GetClassUpdateData();
    this.updateRoom();
  }

  getSelectedStaff(trainer: any) {
    this.onTrainerChange(trainer);
  }

  updateRoom() {
    this.UpdateClass(this.GetClassUpdateData()).then((res) => {
      if (res) {
        this.classData().room_id = this.GetSelectedRoomFormValue
          ? this.GetSelectedRoomFormValue.id
          : 0;
        this.reloadData.emit(true);
      } else {
        this.selectedRoomId.next(this.classData().room_id);
      }
    });
  }

  onDropInChange(event: any) {
    this.updateEvent = 'DropInChange';
    this.currentRequestPayload = this.GetClassUpdateData();
    this.UpdateDropInStatus();
  }

  UpdateDropInStatus() {
    this.UpdateClass(this.GetClassUpdateData()).then((res) => {
      if (res) {
        this.classObj.is_dropin_allowed = this.GetDropInFormValue;
        this.reloadData.emit(true);
      } else {
        this.selectedDropin = this.dropIns.find(
          (d) => d.value == this.classObj.is_dropin_allowed,
        );
        this.DropInFormControl.setValue(this.selectedDropin);
      }
    });
  }

  onAcceptTrialChange(event: any) {
    this.isAcceptTrialChecked = event.checked;
    this.updateEvent = 'AcceptsTrialChange';
    this.currentRequestPayload = this.GetClassUpdateData();
    this.UpdateAcceptsTrial();
  }

  UpdateAcceptsTrial() {
    this.UpdateClass(this.GetClassUpdateData()).then((res) => {
      if (res) {
        this.AcceptsTrialFormControl.setValue(this.isAcceptTrialChecked);
        this.reloadData.emit(true);
      } else {
        this.AcceptsTrialFormControl.setValue(this.classData().accepts_trial);
      }
    });
  }

  async onTrainerChange(trainer: any) {
    const substituteCoach: SubstituteCoachInClassRequest =
      {} as SubstituteCoachInClassRequest;
    substituteCoach.coach_id = trainer.id;
    this.updateEvent = 'TrainerChange';
    this.currentRequestPayload = substituteCoach;
    this.checkStaffAvailability();
    await this.timeout(500);
    await this.SubstituteCoachInRecurring(substituteCoach);
  }

  public onCommentsKeyUpDelay(value: string): void {
    this.comments.next(value);
  }

  public onKeyUpDelay(value: string): void {
    this.url.next(value);
  }

  EditCommnentsEvent() {
    this.updateEvent = 'CommentsChange';
    this.currentRequestPayload = this.GetClassUpdateData();
    this.UpdateCommnets();
  }

  UpdateCommnets() {
    const updateData = this.GetClassUpdateData();
    this.UpdateClass(updateData).then((res) => {
      if (res) {
        this.classObj.comments = updateData.comments;
        this.reloadData.emit(true);
      } else {
        this.CommentsFormControl.setValue(this.classObj.comments);
      }
    });
  }

  EditMaxCapacity(event: boolean) {
    this.reservationLimitEdit = false;
    if (event) {
      this.updateEvent = 'MaxCapacityChange';
      const updateData = this.GetClassUpdateData();
      this.UpdateMaxCapacityAndWaitlist();
    } else {
      this.MaxCapacityFormControl.setValue(this.classData().max_capacity);
    }
    this.MaxCapacityFormControl.updateValueAndValidity();
  }

  EditMaxWaitlist(event: boolean) {
    this.waitListEdit = false;
    if (event) {
      this.updateEvent = 'MaxWaitlistChange';
      const updateData = this.GetClassUpdateData();
      this.currentRequestPayload = updateData;
      this.UpdateMaxCapacityAndWaitlist();
    } else {
      this.MaxWaitListFormControl.setValue(this.classData().max_waitlist);
    }
  }

  UpdateMaxCapacityAndWaitlist() {
    const updateData = this.GetClassUpdateData();
    this.UpdateClass(updateData).then((res) => {
      if (res) {
        const classData = this.classData();
        classData.max_capacity = updateData.max_capacity;
        this.classObj.max_capacity = updateData.max_capacity;
        classData.max_waitlist = updateData.max_waitlist;
        this.classObj.max_waitlist = updateData.max_capacity;
        this.MaxCapacityFormControl.setValue(classData.max_capacity);
        this.MaxWaitListFormControl.setValue(classData.max_waitlist);
        this.reloadData.emit(true);
      } else {
        const classData = this.classData();
        this.MaxCapacityFormControl.setValue(classData.max_capacity);
        this.MaxWaitListFormControl.setValue(classData.max_waitlist);
      }
      this.MaxCapacityFormControl.updateValueAndValidity();
      this.MaxWaitListFormControl.updateValueAndValidity();
    });
  }

  UpdateVirtualURLEvent() {
    this.updateEvent = 'VirtualUrlChange';
    this.currentRequestPayload = this.GetClassUpdateData();
    this.UpdateVirtualUrl();
  }

  UpdateVirtualUrl() {
    const updateData = this.GetClassUpdateData();
    this.UpdateClass(updateData).then((res) => {
      if (res) {
        this.classData().is_virtual = updateData.is_virtual;
        this.classData().room_id = updateData.room_id;
        this.classObj.virtual_url = updateData.virtual_url;
        this.reloadData.emit(true);
      } else {
        this.VirtualUrlFormControl.setValue(this.classObj.virtual_url);
      }
    });
  }

  FetchRRuleData(e: any): void {
    this.RRuleObject.RRule = e.RRule;
    this.RRuleObject.RRuleText = e.RRuleText;
    this.OnScheduleDateSelect(null);
  }

  HideRRule(e: any): void {
    this.showRRule = e;
  }

  clearRRule(): void {
    this.showRRule = false;
    this.RRuleObject.RRule = undefined as any;
    this.RRuleObject.RRuleText = undefined as any;
  }

  getPlaceDetails(place: any) {
    this.selectedLocation.name = place.formatted_address;
    this.selectedLocation.lat = place.geometry.location.lat();
    this.selectedLocation.lon = place.geometry.location.lng();
    this.PlaceNameControl.setValue(this.selectedLocation.name);
    this.PlaceIdFormControl.setValue(place.place_id);
    this.LatitudeFormControl.setValue(this.selectedLocation.lat);
    this.LongitudeFormControl.setValue(this.selectedLocation.lon);

    this.UpdateClass(this.GetClassUpdateData()).then((res) => {
      if (res) {
        this.emitUpdatedData.emit({
          class: this.classData(),
        });
      }
    });
  }

  GetClassUpdateData(): UpdateClassRequest {
    const updateClassRequest: UpdateClassRequest = {} as UpdateClassRequest;
    updateClassRequest.room_id = this.isVirtal
      ? 0
      : this.GetSelectedRoomFormValue
        ? this.GetSelectedRoomFormValue.id
        : 0;
    updateClassRequest.is_virtual = this.isVirtal;
    updateClassRequest.virtual_url = this.isVirtal
      ? this.GetVirtualUrlFormValue
      : '';
    updateClassRequest.comments = this.GetCommentsFormValue;
    updateClassRequest.max_capacity = this.GetMaxCapacityFormValue;
    updateClassRequest.max_waitlist = this.GetMaxWaitListFormValue;
    updateClassRequest.is_dropin_allowed = this.GetDropInFormValue;
    updateClassRequest.place_id = this.PlaceIdFormControl.value;
    updateClassRequest.latitude = this.LatitudeFormControl.value;
    updateClassRequest.longitude = this.LongitudeFormControl.value;
    updateClassRequest.accepts_trial = this.AcceptsTrialFormControl.value;
    updateClassRequest.auto_bump_waitlist = this.classObj.auto_bump_waitlist;
    return updateClassRequest;
  }

  ShowToastErrors(error: any) {
    if (error.originalError.error.length > 0) {
      error.originalError.error.forEach((e: any) => {
        this.toastMessageService.showErrorMessage(e.errorMessage);
      });
    } else {
      this.toastMessageService.showErrorMessage(
        error.originalError.error.errorMessage,
      );
    }
  }

  async UpdateClass(updateClassRequest: UpdateClassRequest): Promise<boolean> {
    this.showSkeleton$.next(true);
    const promise: Promise<boolean> = new Promise((resolve, reject) => {
      let service = new Observable<any>();
      service = this.classService.UpdateRecurringClass(
        this.tenantId(),
        this.classObj.recurring_template_id,
        updateClassRequest,
      );
      service.subscribe({
        next: () => {
          this.translate
            .get('SCHEDULE.VIEWCLASS.MSG.CLASS_UPDATE')
            .subscribe((translation) => {
              this.toastMessageService.showSuccess(translation);
            });
          this.showSkeleton$.next(false);
          resolve(true);
        },
        error: (error: AppErrors) => {
          this.showSkeleton$.next(false);
          this.ShowToastErrors(error);
          resolve(false);
        },
      });
    });
    return promise;
  }

  async SubstituteCoachInRecurring(
    substituteCoach: SubstituteCoachInClassRequest,
  ) {
    this.showSkeleton$.next(true);
    this.classService
      .SubstituteCoachInRecurring(
        this.tenantId(),
        this.classObj.recurring_template_id,
        substituteCoach,
      )
      .subscribe({
        next: () => {
          this.translate
            .get('SCHEDULE.VIEWCLASS.MSG.COACH_CHANGE')
            .subscribe((translation) => {
              this.toastMessageService.showSuccess(translation);
            });
          this.showSkeleton$.next(false);
          this.reloadData.emit(true);
        },
        error: (error: AppErrors) => {
          this.selectedTrainerId.next(this.classData().coach_id);
          this.showSkeleton$.next(false);
          this.ShowToastErrors(error);
        },
      });
  }

  RescheduleRecurringClass() {
    this.showSkeleton$.next(true);
    const rescheduleRecurringClassRequest: RescheduleRecurringClassRequest =
      {} as RescheduleRecurringClassRequest;
    rescheduleRecurringClassRequest.recurring_rule = this.RRuleObject.RRule;
    rescheduleRecurringClassRequest.start_date =
      this.timeConversionService.ConvertLocalDateTimeToUTC(
        this.GetStartDateFormValue,
      );
    rescheduleRecurringClassRequest.start_time =
      this.timeConversionService.GetUTCTimeFromDate(this.GetStartDateFormValue);
    this.classService
      .RescheduleRecurringClass(
        this.tenantId(),
        this.classObj.recurring_template_id,
        rescheduleRecurringClassRequest,
      )
      .subscribe({
        next: () => {
          this.translate
            .get('SCHEDULE.VIEWCLASS.MSG.CLASS_RESCHEDULE_CHANGE')
            .subscribe((translation) => {
              this.toastMessageService.showSuccess(translation);
            });
          this.classData().start_datetime = this.GetStartDateFormValue;
          this.classData().end_datetime = this.getEndDate();
          this.showSkeleton$.next(false);
          this.reloadData.emit(true);
        },
        error: (error: AppErrors) => {
          this.showSkeleton$.next(false);
          this.ShowToastErrors(error);
          this.StartDateFormControl.setValue(
            this.setFullDate(
              this.classData().recurring_start_date,
              this.classData().start_time,
            ),
            { onlySelf: true },
          );
        },
      });
  }

  CancelClass(form: any) {
    const cancelRequest: CancelClassRequest = {} as CancelClassRequest;
    cancelRequest.cancellation_reason = form.value.cancellation_reason;
    this.classService
      .CancelRecurringClassTemplate(
        this.tenantId(),
        this.classObj.recurring_template_id,
        cancelRequest,
      )
      .subscribe({
        next: () => {
          this.translate
            .get('SCHEDULE.VIEWCLASS.MSG.CANCEL_MSG')
            .subscribe((translation) => {
              this.toastMessageService.showSuccess(translation);
            });
          this.cancelClassPopup = false;
          this.reloadData.emit(true);
          this.ClosePopup();
        },
        error: (error: AppErrors) => {
          this.cancelClassPopup = false;
          this.ShowToastErrors(error);
        },
      });
  }

  MarkClassComplete(markCompleted: boolean) {
    if (!markCompleted) {
      this.classService
        .MarkClassComplete(this.tenantId(), this.classObj.recurring_template_id)
        .subscribe({
          next: () => {
            this.translate
              .get('SCHEDULE.VIEWCLASS.MSG.COMPLETE_MSG')
              .subscribe((translation) => {
                this.toastMessageService.showSuccess(translation);
              });
            this.markCompleted = true;
            this.classObj.status = ClassStatus.Completed;
          },
          error: (error: AppErrors) => {
            this.ShowToastErrors(error);
            this.deleteClassPopup = false;
          },
        });
    }
  }

  timeout(ms: any) {
    return new Promise((resolve) => setTimeout(resolve, ms));
  }

  async UpdateEvent(event: boolean, clickEvent: any = null) {
    switch (this.updateEvent) {
      case 'TrainerChange':
        {
          if (event && clickEvent != null) {
            this.checkStaffAvailability(clickEvent);
          } else if (event && clickEvent == null) {
            this.SubstituteCoachInRecurring(this.currentRequestPayload);
            this.showRecurringEventUpdatePopup = false;
            this.isStaffAvailable = true;
          } else {
            this.selectedTrainerId.next(this.classObj.coach_id);
            this.showRecurringEventUpdatePopup = false;
          }
        }
        break;
      case 'MaxCapacityChange':
      case 'MaxWaitlistChange':
        {
          if (event) {
            this.UpdateMaxCapacityAndWaitlist();
          } else {
            const classData = this.classData();
            this.MaxCapacityFormControl.setValue(classData.max_capacity);
            this.MaxWaitListFormControl.setValue(classData.max_waitlist);
          }
        }
        break;
      case 'VirtualUrlChange':
        {
          if (event) {
            this.UpdateVirtualUrl();
          } else {
            this.VirtualUrlFormControl.setValue(this.classObj.virtual_url);
          }
          this.showRecurringEventUpdatePopup = false;
        }
        break;
      case 'DropInChange':
        {
          if (event) {
            this.UpdateDropInStatus();
          } else {
            this.selectedDropin = this.dropIns.find(
              (d) => d.value == this.classObj.is_dropin_allowed,
            );
            this.DropInFormControl.setValue(this.selectedDropin);
          }
          this.showRecurringEventUpdatePopup = false;
        }
        break;
      case 'RoomChange':
        {
          if (event) {
            this.updateRoom();
          } else {
            this.selectedRoomId.next(this.classData().room_id);
          }
          this.showRecurringEventUpdatePopup = false;
        }
        break;
      case 'CommentsChange':
        {
          if (event) {
            this.UpdateCommnets();
          } else {
            this.CommentsFormControl.setValue(this.classObj.comments);
          }
          this.showRecurringEventUpdatePopup = false;
        }
        break;
      case 'OnScheduleDateTimeChange':
      case 'OnScheduleTimeChange':
        {
          if (event && clickEvent != null && this.checkAvailability) {
            this.checkStaffAvailability(clickEvent);
          } else if (
            event &&
            (clickEvent == null || this.checkAvailability == false)
          ) {
            this.RescheduleRecurringClass();
            this.showRecurringEventUpdatePopup = false;
            this.isStaffAvailable = true;
          } else {
            this.StartDateFormControl.setValue(
              this.classData().start_datetime,
              { onlySelf: true },
            );
            this.showRecurringEventUpdatePopup = false;
          }
        }
        break;
      case 'AcceptsTrialChange':
        {
          if (event) {
            this.UpdateAcceptsTrial();
          } else {
            this.AcceptsTrialFormControl.setValue(
              this.classData().accepts_trial,
            );
          }
          this.showRecurringEventUpdatePopup = false;
        }
        break;
    }
  }

  confirm(event: Event) {
    let translation: any;
    this.translate
      .get([
        'STAFF_SCHEDULE.MSG.WANT_CHANGES_PROCEES',
        'common.BUTTONS.BUTTON-TEXT-YES',
        'common.BUTTONS.BUTTON-TEXT-NO',
      ])
      .subscribe((translations) => {
        translation = translations;
      });
    this.confirmationService.confirm({
      target: event.target as EventTarget,
      key: 'bookconfirm',
      message: translation['STAFF_SCHEDULE.MSG.WANT_CHANGES_PROCEES'],
      icon: 'fa fa-exclamation-triangle',
      acceptLabel: translation['common.BUTTONS.BUTTON-TEXT-YES'],
      rejectLabel: translation['common.BUTTONS.BUTTON-TEXT-NO'],
      accept: () => {
        this.UpdateEvent(true);
      },
      reject: () => {
        this.showRecurringEventUpdatePopup = false;
        this.isStaffAvailable = false;
      },
    });
  }

  UpdateClassData(event: any) {
    this.classObj = event;
    this.classData().status = this.classObj.status;
    this.classData().max_capacity = this.classObj.max_capacity;
    this.classData().max_waitlist = this.classObj.max_waitlist;
    this.emitUpdatedData.emit({ class: this.classData() });
  }

  selectAction(action: any) {
    this.selectedClassAction = action.value;
    switch (this.selectedClassAction?.key) {
      case 'DUPLICATE':
        this.duplicateClass = true;
        break;
      case 'CANCEL_CLASS':
        this.cancelClassPopup = true;
        break;
      case 'DELETE':
        this.deleteClassPopup = true;
        break;
      case 'CONVERT_PHYSICAL':
        this.ToggleVirtual(false);
        break;
      case 'CONVERT_VIRTUAL':
        this.ToggleVirtual(true);
        break;
    }
  }

  checkStaffAvailability(event: any = null) {
    if (
      this.selectedClassType &&
      this.StartDateFormControl.value &&
      this.SelectedTrainerFormControl.value.id
    ) {
      this.showSkeleton$.next(true);
      this.btnLoading = true;
      const endDateTime: Date = this.getEndDate();
      endDateTime.setMinutes(
        endDateTime.getMinutes() + this.selectedClassType.duration_in_minutes,
      );
      if (
        this.SelectedUpdateEventFormControlValue.toLowerCase() !== 'thisevent'
      ) {
        const request: CheckRecurringAvailability =
          {} as CheckRecurringAvailability;
        request.recurring_start_date =
          this.timeConversionService.ConvertLocalDateTimeToUTC(
            this.GetStartDateFormValue,
          );
        request.recurring_end_date =
          this.timeConversionService.ConvertLocalDateTimeToUTC(endDateTime);
        request.start_time = this.getTimeFromDateString(
          this.StartDateFormControl.value,
        );
        request.end_time = this.getTimeFromEndDateString(endDateTime);
        request.recurring_rule = this.RRuleObject.RRule;
        this.staffAvailabilityService
          .checkStaffAvailabilityForRecurringClass(
            this.tenantId(),
            this.SelectedTrainerFormControl.value.id,
            request,
          )
          .subscribe({
            next: async (response: StaffAvailableResponse) => {
              this.isStaffAvailable = response.result;
              this.availabilityResponseHandle(event);
            },
            error: () => {
              this.isStaffAvailable = true;
              this.showSkeleton$.next(false);
              this.availabilityResponseHandle(event);
              this.cd.detectChanges();
            },
          });
      } else {
        this.staffAppointmentAvailability.set('start_date', {
          name: 'start_date',
          value: this.timeConversionService.ConvertLocalDateTimeToUTC(
            this.GetStartDateFormValue,
          ),
        });
        this.staffAppointmentAvailability.set('end_date', {
          name: 'end_date',
          value:
            this.timeConversionService.ConvertLocalDateTimeToUTC(endDateTime),
        });
        this.staffAvailabilityService
          .checkStaffAvailabilityForClass(
            this.tenantId(),
            this.SelectedTrainerFormControl.value.id,
            [...this.staffAppointmentAvailability.values()],
          )
          .subscribe({
            next: async (response: StaffAvailableResponse) => {
              this.isStaffAvailable = response.result;
              this.availabilityResponseHandle(event);
              this.cd.detectChanges();
            },
            error: () => {
              this.isStaffAvailable = true;
              this.showSkeleton$.next(false);
              this.availabilityResponseHandle(event);
              this.cd.detectChanges();
            },
          });
      }
    }
  }

  availabilityResponseHandle(event: any) {
    if (this.isStaffAvailable) {
      switch (this.updateEvent) {
        case 'TrainerChange':
          {
            this.SubstituteCoachInRecurring(this.currentRequestPayload);
          }
          break;
        case 'OnScheduleTimeChange':
        case 'OnScheduleDateSelect':
          {
            this.RescheduleRecurringClass();
          }
          break;
      }
      this.btnLoading = false;
      this.showRecurringEventUpdatePopup = false;
      this.cd.detectChanges();
    } else {
      this.btnLoading = false;
      const dynamicContent = {
        name: this.SelectedTrainerFormControl.value.name,
        id: this.SelectedTrainerFormControl.value.id,
      };
      this.toastService.showCustomWarning('', 'main_template', dynamicContent);
      this.confirm(event);
      this.cd.detectChanges();
    }
  }

  getTimeFromDateString(dateString: any) {
    if (dateString == '') return `00:00:00`;
    const date =
      this.timeConversionService.ConvertLocalDateTimeToUTCInDateObject(
        dateString,
      );
    const hours = date.getHours();
    const minutes = date.getMinutes();
    const formattedTime = `${hours.toString().padStart(2, '0')}:${minutes.toString().padStart(2, '0')}:00`;
    return formattedTime;
  }

  getTimeFromEndDateString(dateString: any) {
    if (dateString == '') return `00:00:00`;
    const date =
      this.timeConversionService.ConvertLocalDateTimeToUTCInDateObject(
        dateString,
      );
    const hours = date.getHours();
    const minutes = date.getMinutes();
    date.setSeconds(-1);
    const formattedTime = `${hours.toString().padStart(2, '0')}:${minutes.toString().padStart(2, '0')}:00`;
    return formattedTime;
  }

  getEndDate() {
    const newEndDate = new Date(this.GetStartDateFormValue);
    return new Date(
      newEndDate.setMinutes(
        this.GetStartDateFormValue.getMinutes() +
          this.classObj.duration_in_minutes,
      ),
    );
  }

  setFullDate(date: Date, timeString: string, convertToLocal: boolean = true) {
    const [hours, minutes] = timeString.split(':');
    const dateobj = new Date(date);
    dateobj.setHours(parseInt(hours));
    dateobj.setMinutes(parseInt(minutes));
    if (convertToLocal)
      return this.timeConversionService.ConvertUTCToLocalDateTime(dateobj);
    else return dateobj;
  }

  get getClassActions() {
    return this.classActions.filter((o) => o.show == true);
  }

  get StartDateFormControl(): UntypedFormControl {
    return this.classViewForm.controls.startDate as UntypedFormControl;
  }

  get GetStartDateFormValue(): Date {
    return this.classViewForm.controls.startDate.value;
  }

  get MaxCapacityFormControl(): UntypedFormControl {
    return this.classViewForm.controls.maxCapacity as UntypedFormControl;
  }

  get GetMaxCapacityFormValue(): any {
    return this.classViewForm.controls.maxCapacity.value;
  }

  get MaxWaitListFormControl(): UntypedFormControl {
    return this.classViewForm.controls.maxWaitlist as UntypedFormControl;
  }

  get GetMaxWaitListFormValue(): any {
    return this.classViewForm.controls.maxWaitlist.value;
  }

  get SelectedTrainerFormControl(): UntypedFormControl {
    return this.classViewForm.controls.selectedTrainer as UntypedFormControl;
  }

  get GetSelectedTrainerFormValue(): any {
    return this.classViewForm.controls.selectedTrainer.value;
  }

  get SelectedRoomFormControl(): UntypedFormControl {
    return this.classViewForm.controls.selectedRoom as UntypedFormControl;
  }
  get GetSelectedRoomFormValue(): any {
    return this.classViewForm.controls.selectedRoom.value;
  }

  get CommentsFormControl(): UntypedFormControl {
    return this.classViewForm.controls.comments as UntypedFormControl;
  }

  get GetCommentsFormValue(): any {
    return this.classViewForm.controls.comments.value;
  }

  get VirtualUrlFormControl(): UntypedFormControl {
    return this.classViewForm.controls.virtualUrl as UntypedFormControl;
  }

  get GetVirtualUrlFormValue(): any {
    return this.classViewForm.controls.virtualUrl.value;
  }

  get DropInFormControl(): UntypedFormControl {
    return this.classViewForm.controls.isDropInAllowed as UntypedFormControl;
  }

  get GetDropInFormValue(): any {
    return this.classViewForm.controls.isDropInAllowed.value.value;
  }

  get PlaceIdFormControl(): UntypedFormControl {
    return this.classViewForm.controls.placeId as UntypedFormControl;
  }

  get LongitudeFormControl(): UntypedFormControl {
    return this.classViewForm.controls.longitude as UntypedFormControl;
  }

  get LatitudeFormControl(): UntypedFormControl {
    return this.classViewForm.controls.latitude as UntypedFormControl;
  }

  get PlaceNameControl(): UntypedFormControl {
    return this.classViewForm.controls.placeName as UntypedFormControl;
  }

  get clientBookingStatus() {
    return ClientBookingStatus;
  }

  public get ClassStatus(): typeof ClassStatus {
    return ClassStatus;
  }

  get SelectedUpdateEventFormControlValue(): any {
    return this.updateEventForm.controls.updateEvent.value;
  }

  get OStaffStatus(): Ienum<StaffStatus>[] {
    return Object.entries(StaffStatus)
      .filter((key) => typeof key[1] != 'number')
      .map(([key, value]) => ({ key, value }));
  }

  get AcceptsTrialFormControl(): UntypedFormControl {
    return this.classViewForm.controls.accepts_trial as UntypedFormControl;
  }

  get SelectedBehaviourTypeFormControl(): UntypedFormControl {
    return this.classViewForm.controls
      .selectedBehaviourType as UntypedFormControl;
  }

  get SelectedClassTypeFormControl(): UntypedFormControl {
    return this.classViewForm.controls.classType as UntypedFormControl;
  }

  get SelectedClassSubTypeFormControl(): UntypedFormControl {
    return this.classViewForm.controls.classSubType as UntypedFormControl;
  }

  get SelectedActionFormControl(): UntypedFormControl {
    return this.classViewForm.controls.selectedAction as UntypedFormControl;
  }

  get showSkeleton() {
    return this.showSkeleton$.value;
  }
}
